import ApiError from 'types/ApiError';

export const isApiError = (object: any | ApiError) => {
  return 'status' in object || 'message' in object;
};

export const hasApiError = (array: Array<any>) => {
  return !!array.find((item: any) => isApiError(item));
};
